// src/components/BalanceCard.js
import React from 'react';
import { useBalance } from '../../hooks/useApi';

const BalanceCard = ({ account }) => {
  const { balance, loading } = useBalance(account);

  if (loading) return <div>Chargement...</div>;

  return (
    <div className="balance-card">
      <h3>Solde actuel</h3>
      <p>{balance} €</p>
    </div>
  );
};

export default BalanceCard;
